function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.333 10.668a.992.992 0 01-.707-.294L.293 6.041a1 1 0 011.415-1.415l3.626 3.627 7.96-7.96a1 1 0 011.415 1.415l-8.667 8.666a1.002 1.002 0 01-.709.293z",
  fill: "currentColor"
});

function SvgIconTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 11"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxMSI+CiAgPHBhdGggZD0iTTUuMzMzIDEwLjY2OGEuOTkyLjk5MiAwIDAxLS43MDctLjI5NEwuMjkzIDYuMDQxYTEgMSAwIDAxMS40MTUtMS40MTVsMy42MjYgMy42MjcgNy45Ni03Ljk2YTEgMSAwIDAxMS40MTUgMS40MTVsLTguNjY3IDguNjY2YTEuMDAyIDEuMDAyIDAgMDEtLjcwOS4yOTN6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgIconTick as ReactComponent };